export function validateSubscription(data: Record<string, unknown>): string[] {
    const errors: string[] = [];

    if (!data.label) {
        errors.push('Libellé requis.');
    }

    return errors;
}
